<template>
  <Modal v-model="show" title="快速新建" :closable="false" :mask-closable="false" width="600px">
    <Form ref="formData" :model="formData" :rules="rules" :label-width="150">
      <FormItem prop="name" label="项目名称：">
        <Input type="text" v-model.trim="formData.name" placeholder="请输入" />
      </FormItem>
      <FormItem prop="life" label="项目周期(天)：">
        <InputNumber v-model="formData.life" :min="1" placeholder="请输入" style="width: 100%" />
      </FormItem>
      <FormItem prop="add_author" label="作者添加进成员：">
        <RadioGroup v-model="formData.add_author">
          <Radio :label="1">是</Radio>
          <Radio :label="0">否</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <template #footer>
      <Button type="default" @click="show = false">取消</Button>
      <Button type="primary" @click="handleSubmit('formData')" :loading="loading">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { Form, FormItem, Input, Modal, Button, RadioGroup, Radio, InputNumber } from 'view-design'
export default {
  components: { Form, FormItem, Input, Modal, Button, RadioGroup, Radio, InputNumber },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    createObj: {
      type: Object,
      default: () => {},
      required: true
    },
    tplType: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data() {
    return {
      formData: {
        name: '',
        add_author: 0,
        life: 1
      },
      loading: false,
      rules: {
        name: [
          {
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }
        ],
        life: [
          {
            type: 'number',
            required: true,
            message: '请输入项目周期',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.handleOk()
        }
      })
    },
    async handleOk() {
      const params = {
        uriCode: 'ZP_API004',
        ...this.formData,
        life: +this.formData.life,
        template_id: this.createObj.id,
        type: this.tplType
      }

      try {
        this.loading = true
        await this.$fetch(params)
      } finally {
        this.loading = false
        this.show = false
        this.$emit('ok')
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.$refs['formData'].resetFields()
      } else {
        this.formData.name = this.createObj.name
        this.formData.life = this.createObj.life
      }
    }
  }
}
</script>
